import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FanFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M5.64 19.12C4.14 19.12 3.18 18.04 3.18 16.42C3.18 13.82 5.72 11.26 8.26 11.26C8.78 11.26 9.34 11.36 10.1 11.86L11.6 11C10.02 9.84 9.14 8.02 9.14 6.36C9.14 4.52 10.24 3.16 11.68 3.16C13.96 3.16 15.68 5.56 15.68 8.12C15.68 9.58 15.12 10.84 13.84 11.64V13.32C14.72 12.94 15.34 12.82 16 12.82C18.88 12.82 20.82 14.42 20.82 16.32C20.82 17.86 19.2 19.1 17.18 19.1C14.46 19.1 12.42 17.56 12.14 15L10.4 13.98C10.14 16.82 7.8 19.12 5.64 19.12Z" />
    </SvgIcon>
  );
});
